// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"89e5a5cf","453":"7b7ba80b"}[chunkId] + ".chunk.js";
};